'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n  padding: 0.5em;\n  margin: 5px;\n  text-align: center;\n  display: inline-block;\n  border-radius: 4px\n'], ['\n  cursor: pointer;\n  padding: 0.5em;\n  margin: 5px;\n  text-align: center;\n  display: inline-block;\n  border-radius: 4px\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 19px;\n'], ['\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 19px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonRadio = _styledComponents2.default.div(_templateObject);

var Label = _styledComponents2.default.span(_templateObject2);

var MozartButtonRadio = function (_Component) {
  _inherits(MozartButtonRadio, _Component);

  function MozartButtonRadio(props) {
    _classCallCheck(this, MozartButtonRadio);

    var _this = _possibleConstructorReturn(this, (MozartButtonRadio.__proto__ || Object.getPrototypeOf(MozartButtonRadio)).call(this, props));

    _this.state = {
      data: Object.assign({}, _this.props.data)
    };
    return _this;
  }

  _createClass(MozartButtonRadio, [{
    key: 'getButtonRadio',
    value: function getButtonRadio() {
      var _this2 = this;

      var _props = this.props,
          radioStyle = _props.radioStyle,
          textStyle = _props.textStyle;

      var radioStyle_ = Object.assign({}, radioStyle);
      var textStyle_ = Object.assign({}, textStyle);
      var DATA = [];
      Object.keys(this.state.data).forEach(function (key) {
        var radio = _this2.state.data[key];
        radioStyle_.border = '2px solid ' + radio.color;
        if (radio.selected) {
          textStyle_.color = _color2.default.white;
          radioStyle_.backgroundColor = radio.color;
        } else {
          textStyle_.color = radio.color;
          radioStyle_.backgroundColor = _color2.default.white;
        }

        DATA.push(_react2.default.createElement(
          ButtonRadio,
          {
            key: key,
            style: Object.assign({}, radioStyle_),
            onClick: _this2.handleRadioClick.bind(_this2, key)
          },
          _react2.default.createElement(
            Label,
            { style: Object.assign({}, textStyle_) },
            radio.name
          )
        ));
      });
      return DATA;
    }
  }, {
    key: 'handleRadioClick',
    value: function handleRadioClick(selectedKey) {
      var _this3 = this;

      var limit = this.props.limit;

      var newdata = Object.assign({}, this.state.data);

      if (limit === 1) {
        Object.keys(newdata).forEach(function (key) {
          newdata[key].selected = selectedKey === key ? true : false;
        });
      } else {
        var count = 0;
        Object.keys(newdata).forEach(function (key) {
          count = newdata[key].selected ? count + 1 : count;
        });
        if (count < limit) {
          Object.keys(newdata).forEach(function (key) {
            newdata[key].selected = selectedKey === key ? !newdata[key].selected : newdata[key].selected;
          });
        } else {
          Object.keys(newdata).forEach(function (key) {
            newdata[key].selected = selectedKey === key ? false : newdata[key].selected;
          });
        }
      }
      this.setState({ data: newdata }, function () {
        _this3.props.onSelect(_this3.state.data, selectedKey);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': this.props.themeId },
        this.getButtonRadio()
      );
    }
  }]);

  return MozartButtonRadio;
}(_react.Component);

MozartButtonRadio.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  radioStyle: _propTypes2.default.object,
  /** text style override */
  textStyle: _propTypes2.default.object,
  /** data  array of object {name, selected, color} */
  data: _propTypes2.default.array,
  /** limit number of selectable */
  limit: _propTypes2.default.number,
  /** callback on select */
  onSelect: _propTypes2.default.func.isRequired
};
MozartButtonRadio.defaultProps = {
  limit: 1,
  textStyle: {},
  radioStyle: {},
  testId: 'MozartButtonRadio',
  themeId: 'MozartButtonRadio'
};
exports.default = MozartButtonRadio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartButtonRadio/MozartButtonRadio.js
// module id = 1833
// module chunks = 1